const BASE = '/api/v1';

/**
 * Fetch the UN R155 checklist for a session.
 * Creates a default checklist on the backend if one doesn't exist yet.
 */
export async function getUNR155Checklist(sessionId) {
  const response = await fetch(`${BASE}/session/${sessionId}/unr155-checklist`, {
    credentials: 'include',
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to load UN R155 checklist: ${text}`);
  }
  return response.json();
}

/**
 * Update a single checklist item's relevance and optional rationale.
 */
export async function updateUNR155Item(sessionId, { item_id, relevance, rationale }) {
  const response = await fetch(`${BASE}/session/${sessionId}/unr155-checklist/item`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ item_id, relevance, rationale: rationale ?? null }),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to update checklist item: ${text}`);
  }
  return response.json();
}
